import { render } from "./ContactEditor.vue?vue&type=template&id=ba95b7f2&scoped=true"
import script from "./ContactEditor.vue?vue&type=script&lang=ts"
export * from "./ContactEditor.vue?vue&type=script&lang=ts"

import "./ContactEditor.vue?vue&type=style&index=0&id=ba95b7f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ba95b7f2"

export default script